import React from 'react';
import Slider from 'react-rangeslider';
import ReactDOM from "react-dom";
import ShopProfile from './shopProfile';
//import 'react-rangeslider/lib/index.css';
import '../mainCSS/range.css';


export default class PriceRange extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            //value: 2,
            minValue: 0,
            maxValue: 0,
            lenght: ShopProfile.getRangeLenght(),
            //Ez a felső csuszka 50 hosszal
            minlenght: ShopProfile.getRangeMinlenght()
        }
    }

    componentDidMount() {
        //szerver lekérdezése...
        var minPrice = 0;
        var maxPrice = ShopProfile.getPriceMax();
        //kiválsztott értékek, ha vannak.
        if (ShopProfile.getPriceMin() !== 0) {
            this.setState({
                minValue: ShopProfile.getPriceMin()
            })
        } else {
            this.setState({
                minValue: minPrice
            })
        }
        if (ShopProfile.getPriceMax() !== 0) {
            this.setState({
                maxValue: ShopProfile.getPriceMax()
            })
        } else {
            this.setState({
                maxValue: maxPrice
            })
        }
    }

    handleChangeStart = () => {
        //console.log('Change event started')
    };

    handleChangeMin = minValue => {
        var { maxValue } = this.state;
        var { lenght } = this.state;
        var { minlenght } = this.state;
        var e = document.getElementById("min");
        ShopProfile.setPriceMin(minValue);
        if (minValue > ((maxValue / 2) - 1)) {
            //var e = document.getElementById("min");
            e.style = "width: 100%";
            minlenght = lenght;
        } else {
            if (minValue < minlenght) {
                //var e = document.getElementById("min");
                e.style = "width: 50%";
                minlenght = lenght / 2;
            }
        }
        this.setState({
            minValue: minValue,
            minlenght: minlenght
        })
    };

    handleChangeMax = maxValue => {
        ShopProfile.setPriceMax(maxValue);
        this.setState({
            maxValue: maxValue
        })
    };

    handleChangeComplete = () => {
        //console.log('Change event complete')
    };

    multiRangeMax() {
        var { maxValue } = this.state;
        var { lenght } = this.state;
        return (
            <div className='max'>
                <Slider
                    step={1}
                    min={0}
                    max={lenght}
                    value={maxValue}
                    dual={false}
                    //onChangeStart={this.handleChangeStart}
                    onChange={this.handleChangeMax}
                //onChangeComplete={this.handleChangeComplete}
                />
            </div>
        )
    }

    multiRangeMin() {
        var { minValue } = this.state;
        var { minlenght } = this.state;
        return (
            <div id='min'>
                <Slider
                    step={1}
                    min={0}
                    max={minlenght}
                    value={minValue}
                    dual={false}
                    //onChangeStart={this.handleChangeStart}
                    onChange={this.handleChangeMin}
                //onChangeComplete={this.handleChangeComplete}
                />
            </div>
        )
    }

    multiRangeValue() {
        var { minValue } = this.state;
        var { maxValue } = this.state;
        return (
            <div className='value'>{minValue} - {maxValue}</div>
        )
    }

    multiRangeShow() {
        var mrMin = this.multiRangeMin();
        var mrMax = this.multiRangeMax();
        var mrValue = this.multiRangeValue();
        setTimeout(function () {
            ReactDOM.render(
                <div>
                    {mrMax}
                    {mrMin}
                    {mrValue}
                </div>,
                document.getElementById('slider')
            );
        }, 100);
    }

    render() {
        //const { value } = this.state;
        var mrMin = this.multiRangeMin();
        var mrMax = this.multiRangeMax();
        var mrValue = this.multiRangeValue();
        return (
            <div id='slider'>
                <div>
                    <h2>Ár szűkítése</h2>
                    {mrMax}
                    {mrMin}
                    {mrValue}
                </div>
            </div>
        )
    }
}